/**生成随机字符串 */
export function randomRange(min: number, max: number) {
  let returnStr = '',
    range = max ? Math.round(Math.random() * (max - min)) + min : min,
    arr = [
      '0',
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ]
  for (let i = 0; i < range; i++) {
    let index = Math.round(Math.random() * (arr.length - 1))
    returnStr += arr[index]
  }
  return returnStr
}

/**获取cookie对象 */
export function getCookies(cookie: string) {
  const cookies: Record<string, string> = {}
  ;(cookie || '').split(';').map((item: string) => {
    item = item.replace(/'/g, '').replace(/ /g, '')
    const key = item.split('=')[0]
    const value = item.split('=')[1]
    cookies[key] = value
  })
  return cookies
}

/**graphql错误信息处理 */
export const graphQLErrorMessage = (error: any) => {
  if (error?.message === 'Failed to fetch') {
    return '网络错误，请检查网络连接后重试...'
  }
  /**跟后端约定：code末尾为0000代表可使用接口给的message，否则用前端自定义的兜底message */
  if (Number(error?.graphQLErrors?.[0]?.extensions?.code) % 10000 === 0) {
    return (
      error?.graphQLErrors?.[0]?.extensions?.message ||
      error?.graphQLErrors?.[0].message
    )
  }
  return ''
}

export const graphQLErrorCode = (error: any) => {
  return Number(error?.graphQLErrors[0]?.extensions?.code || -1)
}

export const isNotFound = (error: any) => {
  return Number(error?.graphQLErrors?.[0]?.extensions?.code) === 20020008
}

/**获取错误码 */
export const getErrorCode = (error: any) => {
  if (isNotFound(error)) {
    return 404
  }

  return 500
}

/**服务端统一错误处理 */
export const serverSideCatch = async (fn: () => Promise<any>) => {
  try {
    return await fn()
  } catch (err) {
    if (isNotFound(err)) {
      return {
        notFound: true,
      }
    } else {
      throw err
    }
  }
}

/** 任务队列 */
export const queue = () => {
  const list: any[] = []
  let index = 0
  let isStop = false

  const next = () => {
    if (isStop || index >= list.length - 1) return
    const cur = list[++index]
    cur(next)
  }

  const add = (...fn: any[]) => {
    list.push(...fn)
  }

  const run = () => {
    const cur = list[index]
    if (typeof cur === 'function') {
      isStop = false
      cur(next)
    } else {
      isStop = true
    }
  }

  const stop = () => {
    isStop = true
  }

  const del = () => {
    isStop = true
    index = 0
  }

  const retry = () => {
    isStop = false
    index = 0
    run()
  }

  const goOn = () => {
    isStop = false
    next()
  }

  return {
    add,
    run,
    stop,
    retry,
    goOn,
    del,
  }
}

export const trackEvent = ({
  category,
  label,
  event,
  id,
}: {
  category: string
  label: string
  event?: string
  id?: string
}) => {
  if (typeof window !== 'undefined' && window._hmt) {
    window._hmt.push([
      '_trackEvent',
      category,
      event || '点击',
      label,
      '',
      id || 1,
    ])
  }
}

/**
 * 预加载图片资源
 * @param imgs 图片url列表
 * @returns
 */
export function preLoadImgs(imgs: string[]) {
  imgs = imgs?.filter(it => !!it)
  if (!imgs.length) return Promise.reject()
  let count = 1
  return new Promise((resolve, reject) => {
    for (let i = 0; i < imgs.length; i++) {
      let img = new Image()
      img.src = imgs[i]
      img.onload = function () {
        count++
        if (count === imgs.length) {
          resolve(true)
        } else {
          resolve(false)
        }
      }
    }
  })
}

export const setLocalStorage = (data: any, target: string) => {
  window.localStorage.setItem(target, JSON.stringify(data))
}

export const removeLocalStorage = (target: string) => {
  window.localStorage.removeItem(target)
}

export const getLocalStorage = (target: string, defaultValue?: any) => {
  try {
    return JSON.parse(window.localStorage.getItem(target) || `${defaultValue}`)
  } catch (err) {
    return defaultValue
  }
}
